import { render } from "./LabelSelector.vue?vue&type=template&id=3789520e&scoped=true"
import script from "./LabelSelector.vue?vue&type=script&lang=js"
export * from "./LabelSelector.vue?vue&type=script&lang=js"

import "./LabelSelector.vue?vue&type=style&index=0&id=3789520e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3789520e"]])

export default __exports__